import { vi } from "@chotca/config";

export const LOCALE = "vi";
export const MESSAGES = vi as unknown as Record<string, Record<string, string>>;
